import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: 'Questo prodotto è adatto a qualsiasi insegnante di musica?',
    a: 'Sì, il MegaPack è pensato per insegnanti di pianoforte, chitarra, canto, violino, batteria e in generale per chiunque insegni musica.'
  }, {
    q: "Riceverò accesso immediato dopo l'acquisto?",
    a: 'Sì, subito dopo il pagamento riceverai accesso immediato a tutto il materiale digitale.'
  }, {
    q: 'Devo avere esperienza pedagogica per applicarlo?',
    a: 'No, il materiale è stato pensato per essere semplice, pratico e utilizzabile anche da chi non ha una formazione pedagogica avanzata.'
  }, {
    q: 'Il pagamento è unico?',
    a: 'Sì, paghi una sola volta. Non ci sono abbonamenti né costi nascosti.'
  }, {
    q: 'È prevista una garanzia?',
    a: 'Sì, hai una garanzia di 45 giorni per acquistare in totale tranquillità.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 md:py-24 px-4 bg-gray-50" data-id="element-58">
      <div className="max-w-3xl mx-auto" data-id="element-59">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-60">
          Domande Frequenti
        </h2>

        <div className="space-y-4" data-id="element-61">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm" data-id="element-62">
              <button onClick={() => toggleFaq(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-63">
                <span className="font-bold text-gray-900 pr-4" data-id="element-64">{faq.q}</span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className="flex-shrink-0 text-gray-400" data-id="element-65">
                  <ChevronDownIcon className="w-5 h-5" data-id="element-66" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-67">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-68">
                    <div className="px-6 pb-5 text-gray-600 border-t border-gray-100 pt-4" data-id="element-69">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}